
import { mapState, mapMutations } from "vuex";
import { getNapaAltromPage } from "@/graphql/napaAltrom";

export default {
  nuxtI18n: {
    paths: {
      "en-ca": "/support/napaaltrom",
      "fr-ca": "/soutien/napaaltrom",
    },
  },
  async asyncData({ app, i18n }) {
    const client = app.apolloProvider.defaultClient;
    const locale = i18n.locale.slice(0, 3) + i18n.locale.slice(3).toUpperCase();
    const napaAltromResponse = await client.query({
      query: getNapaAltromPage,
      variables: { locale: locale },
    });
    const napaAltromPage = napaAltromResponse.data.napaAltrom.data.attributes;
    return { napaAltromPage };
  },
  data() {
    return {
      napaAltromPage: {},
      show: false,
      anchorSelected: ""
    };
  },
  head() {
    return {
      title: this.napaAltromPage.SEO.MetaTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.napaAltromPage.SEO.MetaDescription,
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.napaAltromPage.SEO.MetaDescription,
        },
        { hid: 'robots', name: 'robots', content: 'noindex, nofollow' },
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    setTimeout(() => this.setPageAnimation("animBanner"), 500);
  },
  computed: {
    ...mapState(["pageScroll"]),
  },
  methods: {
    ...mapMutations({
      setPageAnimation: "SET_PAGE_ANIMATION",
    }),
  },
  watch: {
    pageScroll: function () {
      let haveShow = false;
      if (
        this.$refs.animated?.getBoundingClientRect().bottom -
          window.innerHeight +
          100 <=
        0
      ) {
        this.show = true;
        haveShow = true;
      }
    },
  },
};
